import { render, staticRenderFns } from "./dropdownWrapper.vue?vue&type=template&id=bd8633e0&scoped=true&"
import script from "./dropdownWrapper.vue?vue&type=script&lang=js&"
export * from "./dropdownWrapper.vue?vue&type=script&lang=js&"
import style0 from "./dropdownWrapper.vue?vue&type=style&index=0&id=bd8633e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8633e0",
  null
  
)

export default component.exports